import React, { createContext, useState, useRef } from 'react'
import { CognitoUser, AuthenticationDetails, CognitoUserAttribute } from 'amazon-cognito-identity-js'
import Pool from './UserPool'
import { ToastBuilder, ApiRequestBuilder } from '../Builders';

const AccountContext = createContext();

const Account = (props) => {

    const [userSession, setUserSession] = useState(null)
    const [emulationActive, setEmulationActive] = useState(false)
    const [isGlobal, setIsGlobal] = useState(false)
    const [isAdmin, setIsAdmin] = useState(false)
    const [appUser, setAppUser] = useState(null)
    const portalEmulation = useRef({});
    const currentPartner = useRef(0)
    const dmtAccess = useRef(0)

    const getSession = async (refresh = false) => {
        const resolvedSession = await new Promise((resolve, reject) => {
            const user = Pool.getCurrentUser()

            if (!user) return reject(user)

            user.getSession(async (seshionError, session) => {

                if (seshionError) {
                    logout();
                    return reject(seshionError);
                }

                const userAttributes = await new Promise((resolve, reject) => {

                    user.getUserAttributes((attributesError, attributes) => {

                        if (attributesError) {
                            logout()
                            window.location.href = process.env.PUBLIC_URL
                            return reject(attributesError)
                        }

                        const results = {}

                        for (let attribute of attributes) {
                            const { Name, Value } = attribute
                            results[Name] = Value
                        }

                        resolve(results)
                    })
                })

                let sessionAttributes = {
                    'sub': session.getIdToken().payload['sub'],
                    'name': session.getIdToken().payload['name'],
                    'email': session.getIdToken().payload['email'],
                    'custom:userId': session.getIdToken().payload['custom:userId'],
                    'custom:clientId': session.getIdToken().payload['custom:clientId'],
                    'custom:partnerId': session.getIdToken().payload['custom:partnerId'],
                    'custom:emulationActive': session.getIdToken().payload['custom:emulationActive'],
                }
                /**
                 * Here we determine what level of access the current user has
                 **/
                sessionAttributes = {
                    ...sessionAttributes,
                    'access_level': session.getIdToken().payload['custom:partnerId'] === '0' ? 'global' : session.getIdToken().payload['custom:clientId'] === '0' ? 'partner' : 'client',
                    'portal_emulation_active': session.getIdToken().payload['custom:emulationActive'],
                }

                setAppUser(user);

                if (refresh) {

                    user.refreshSession(session.getRefreshToken(), (err, session) => {
                        if (err) {
                            console.error('Error refreshing session:', err);
                            reject(err);
                        }
                        window.location.href = process.env.PUBLIC_URL
                    });
                }

                const sessionPayload = session.getIdToken().payload;

                const currentSessionDetails = {
                    accessLevel: sessionPayload['custom:partnerId'] === '0' ? 'global' : sessionPayload['custom:clientId'] === '0' ? 'partner' : 'client',
                    // userId: sessionPayload['custom:userId'],
                    partnerId: sessionPayload['custom:partnerId'],
                    // clientId: sessionPayload['custom:clientId'],
                    portalEmulationActive: sessionPayload['custom:emulationActive'],
                };

                /**
                 * Set default color schemes
                 */
                localStorage.setItem('default_color', '#9c9b9a')
                localStorage.setItem('secondary_color', '#009ad4')

                document.getElementById("favicon").href = "https://s3.amazonaws.com/portal.nexnow.io/NexNow+logo+square.jpg"

                const token = session.getIdToken().getJwtToken()
                localStorage.setItem('apiToken', token)
                /**
                 * Now that we have an API token, let's make a call to API Gateway to get
                 * more information about this user's environment.
                 **/
                //  ApiRequestBuilder('partnersPartnerIdGet', { partnerId : attributes['custom:partnerId'] }).then(function(results) {
                //      localStorage.setItem('default_color', results.data[0].default_color)
                //      localStorage.setItem('secondary_color', results.data[0].secondary_color)
                //      document.getElementById("favicon").href = results.data[0].favicon_url
                //     attributes.partner_logo = results.data[0].logo_url
                //  })


                const emulationAttributes = {
                    accessLevel: userAttributes['custom:partnerId'] === '0' ? 'global' : userAttributes['custom:clientId'] === '0' ? 'partner' : 'client',
                    // userId: attributes['custom:userId'],
                    partnerId: userAttributes['custom:partnerId'],
                    // clientId: attributes['custom:clientId'],
                    portalEmulationActive: userAttributes['custom:emulationActive'],
                };

                portalEmulation.current = {
                    accessLevel: emulationAttributes.accessLevel,
                    partnerId: parseInt(emulationAttributes.partnerId),
                    portalEmulationActive: emulationAttributes.portalEmulationActive === 'true'
                };

                /**
                 * Until we determine the best way to access the session context while
                 * creating the menu items, we need to keep things consistent and just
                 * pass this value into localstorage
                 */
                localStorage.setItem('accessLevel', sessionAttributes.access_level)
                setEmulationActive(sessionAttributes.portal_emulation_active === 'true');
                setIsGlobal(sessionAttributes.access_level === 'global');
                setIsAdmin(sessionAttributes.portal_emulation_active === 'true' || sessionAttributes.access_level === 'global');
                currentPartner.current = parseInt(sessionAttributes['custom:partnerId']);

                setUserSession({ ...sessionAttributes, ...session })

                resolve({
                    user,
                    headers: {
                        Authorization: token,
                    },
                    ...session,
                    ...sessionAttributes
                })

            })
        })

        // if (resolvedSession['custom:emulationActive'] === 'true') return await resolvedSession;

        return await ApiRequestBuilder('subscriptionsGet', null, null, null, { conditions: 'tool_id = 7' })
            .then((results) => {
                if (results.data && results.data.length > 0) {
                    let subs = results.data.map((sub) => sub.partner_id)
                    if (subs.includes(currentPartner.current)) {
                        dmtAccess.current = 1;
                    } else {
                        dmtAccess.current = 0;
                    }
                } else {
                    dmtAccess.current = 0;
                }
                return resolvedSession;
            })
    };


    const authenticate = async (Username, Password) =>
        await new Promise((resolve, reject) => {
            const user = new CognitoUser({ Username, Pool })
            const authDetails = new AuthenticationDetails({ Username, Password })

            user.authenticateUser(authDetails, {
                onSuccess: (data) => {
                    /*
                        Before mfa workflow is set up, this is default event.
                        Code below should yield attributes since user is authenticated at this point
                        user.getUserAttributes((err,attributes) => { })
                    */
                    resolve({ status: 'authenticated', user: user })
                },

                onFailure: (err) => {
                    switch (err.name) {
                        case 'UserNotConfirmedException':
                            console.log(err)
                            ToastBuilder('info', 'Please Check Your Email to Verify Your Account')
                            break;
                        case 'NotAuthorizedException':
                            console.log(err)
                            ToastBuilder('error', 'Incorrect username or password.')
                            break;
                        default:
                            console.log(err)
                            ToastBuilder('info', 'Unknown Error on Log In')
                            break;
                    }
                    reject(err)
                },

                newPasswordRequired: (data) => {
                    ToastBuilder('warn', 'You Need to Reset Your Password')
                    resolve(data)
                },

                mfaRequired: function (codeDeliveryDetails) {
                    /*
                        This event should never be emmited unless MFA is set to REQUIRED instead of optional
                        Then I must redirect to request to frontend mfa page
                    */
                },

                totpRequired: function (challengeName, challengeParameters) {
                    /*
                        Once mfa workflow has been set up, set prefered auth SOFTWARE TOKEN and mfa_secret stored in db,
                        this is the default event emitted after successful login with email and password
                    */
                    resolve({ status: 'totpRequired', user: user })
                }
            })
        })

    const emulatePartnerPortal = async (partnerId, partnerName) => {
        ApiRequestBuilder('authEmulateStartPost', null, { partnerId: Number(partnerId) })
            .then((result) => {
                if (result?.data?.success) {
                    localStorage.removeItem(`CognitoIdentityServiceProvider.${process.env.REACT_APP_USER_POOL_APP_CLIENT_ID}.${appUser.getUsername()}.userData`);
                    localStorage.setItem('partnerName', partnerName)
                    getSession(true)
                } else {
                    ToastBuilder('error', 'Unable to enter partner portal.\nPlease contact a Developer.', {}, 10000)
                }
            });
    }

    const exitPartnerPortal = async () => {
        if (appUser) {
            ApiRequestBuilder('authEmulateStopPost', null, {})
                .then((result) => {
                    if (result?.data?.success) {
                        localStorage.removeItem('partnerName');
                        localStorage.removeItem(`CognitoIdentityServiceProvider.${process.env.REACT_APP_USER_POOL_APP_CLIENT_ID}.${appUser.getUsername()}.userData`);
                        getSession(true)
                    } else {
                        ToastBuilder('error', 'Unable to exit partner portal.\nPlease contact a Developer.', {}, 10000)
                    }
                });
        }
    }

    const updateUserAttributes = async (attributes) => {
        if (appUser) {
            const cognitoAttributes = attributes.map(attr => new CognitoUserAttribute(attr));
            return new Promise((resolve, reject) => {
                appUser.updateAttributes(cognitoAttributes, (err, result) => {
                    if (err) {
                        return reject(err);
                    } else {
                        return resolve(result);
                    }
                });
            });
        }
        throw new Error('No authenticated user found');
    }

    const logout = () => {
        const user = Pool.getCurrentUser()
        if (user) {
            user.signOut()
        }
        const lastEmulatedPartner = localStorage.getItem('partnerName');
        const theme = localStorage.getItem('mix_background_layout');
        localStorage.clear();
        if (theme) localStorage.setItem('mix_background_layout', theme);
        if (lastEmulatedPartner) localStorage.setItem('partnerName', lastEmulatedPartner);
    }

    return (
        <AccountContext.Provider
            value={{
                emulatePartnerPortal,
                exitPartnerPortal,
                authenticate,
                getSession,
                logout,
                userSession,
                currentPartner,
                emulationActive,
                portalEmulation: portalEmulation.current,
                isGlobal,
                isAdmin,
                dmtAccess,
                appUser,
            }}
        >
            {props.children}
        </AccountContext.Provider>
    )
}

export { Account, AccountContext }